import * as React from 'react';

import { ReportTypes } from '@showbie-socrative/socrative-utils';

import { translate } from '~l10n/client';

import { IncludeExplanations, ReportOptionType } from '../ReportOption';
import {
  AssessmentsCommonProps,
  AssessmentsExportReportsPanel,
} from './AssessmentsExportReportsPanel';

const AssessmentsExportReportsAnswerKey = (props: AssessmentsCommonProps) => {
  const reportOptions: ReportOptionType[] = [IncludeExplanations];
  return (
    <AssessmentsExportReportsPanel
      {...props}
      description={translate('Export a PDF of the correct quiz answers.')}
      title={translate('Answer Key')}
      reportOptions={reportOptions}
      initialOptions={props.initialOptions}
      reportRequestSelectedType={ReportTypes.EmptyQuiz}
    />
  );
};

export { AssessmentsExportReportsAnswerKey };
export default AssessmentsExportReportsAnswerKey;
